import React, { Component } from 'react';
import { Row, Col, Button, Form, FormGroup, ControlLabel, FormControl, Checkbox } from 'react-bootstrap'
import { getDayOptions, getMonthOptions, getYearOptionsPlus, getYearOptions, MIN_YEAR } from '../../../../Member/Modules/services/dateServices';
import Api from '../../../../Global/Modules/Api'

const FETCH_URL = "api/companies/admin/company"
class Gegevens extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
        this.handleCheckboxArrayChange = this.handleCheckboxArrayChange.bind(this)
        this.state = {
            id: this.props.id,
            memberNumber: "",
            memberLastLogin: "",
            active: false,
            announcements: "",
            gender: "",
            initials: "",
            insertion: "",
            titlePrefix: "",
            address: "",
            city: "",
            mobile: "",
            company: "",
            companyPostCode: "",
            companyPhone: "",
            function: "",
            invoicePostCode: "",
            orderNumber: "",
            submissionDay: "",
            submissionMonth: "",
            submissionYear: "",
            dayRC: "",
            monthRC: "",
            yearRC: "",
            dayRTa: "",
            monthRTa: "",
            yearRTa: "",
            status: "",
            dayReassessment: "",
            monthReassessment: "",
            yearReassessment: "",
            AllGroups: [],
            AllGroups2: [],
            Materials: {
                0: false, 1: false, 2: false, 3: false,
                4: false, 5: false, 6: false, 7: false,
                8: false, 9: false, 10: false, 11: false
            },
            groups: {
                1: false, 2: false, 3: false,
                4: false, 5: false, 6: false
            },
            Title: "",
            firstName: "",
            lastName: "",
            Day: 1,
            Month: 1,
            Year: MIN_YEAR,
            postCode: "",
            phone: "",
            email: "",
            companyAddress: "",
            companyCity: "",
            companyWebsite: "",
            invoiceAddress: "",
            invoiceCity: "",
            contribution: "",
            requestStatus: "",
            dayRO: "",
            monthRO: "",
            yearRO: "",
            dayRTb: "",
            monthRTb: "",
            yearRTb: "",
            overflowPE: "",
            manageAccess: {
                0: false, 1: false, 2: false, 3: false
            },
            permissionFor: {
                0: false, 1: false
            },
            errors: {},
        }
    }
    componentWillMount() {
        var url = "api/members/" + this.props.id;
        Api.GetApi(url).then(data => {
            this.setState({ memberNumber: data.memberNumber })
            this.setState({ memberIdOld: data.idOld })
            this.setState({ memberLastLogin: data.lastLogin })
            this.setState({ CompanyId: data.companyId })
            var list = [];
            for (var key in data.allGroups) {
                list.push(data.allGroups[key])
            }
            this.setState({ AllGroups: list })
            var list2 = [];
            for (var key in data.allGroups2) {
                list2.push(data.allGroups2[key])
            }
            this.setState({ AllGroups2: list2 })
            this.setState({ active: data.active })
            this.setState({ announcements: data.announcements })
            this.setState({ gender: data.gender })
            this.setState({ initials: data.initials })
            this.setState({ middleName: data.middleName })
            this.setState({ insertion: data.insertion })
            this.setState({ address: data.address })
            this.setState({ city: data.city })
            this.setState({ mobile: data.mobile })
            this.setState({ company: data.company })
            this.setState({ companyPostCode: data.companyPostCode })
            this.setState({ companyPhone: data.companyPhone })
            this.setState({ function: data.function })
            this.setState({ requestStatus: data.requestStatus })
            this.setState({ invoicePostCode: data.invoicePostCode })
            this.setState({ orderNumber: data.orderNumber })
            this.setState({ submissionDay: data.requestDay })
            this.setState({ submissionMonth: data.requestMonth })
            this.setState({ submissionYear: data.requestYear })
            this.setState({ dayRC: data.rcDay })
            this.setState({ monthRC: data.rcMonth })
            this.setState({ yearRC: data.rcYear })
            this.setState({ dayRTa: data.rTaDay })
            this.setState({ monthRTa: data.rTaMonth })
            this.setState({ yearRTa: data.rTaYear })
            this.setState({ status: data.status })
            this.setState({ DateFirstReExaminationDay: data.dateFirstReExaminationDay })
            this.setState({ DateFirstReExaminationMonth: data.dateFirstReExaminationMonth })
            this.setState({ DateFirstReExaminationYear: data.dateFirstReExaminationYear })
            for (var key in data.materials) {
                this.setState({ "Materials": { ...this.state["Materials"], [data.materials[key]]: true } })
            }
            for (var key in data.manageAccessList) {
                this.setState({ "manageAccess": { ...this.state["manageAccess"], [data.manageAccessList[key]]: true } })
            }
            for (var key in data.groups) {
                this.setState({ "groups": { ...this.state["groups"], [data.groups[key]]: true } })
            }
            for (var key in data.permissionFor) {
                this.setState({ "permissionFor": { ...this.state["permissionFor"], [data.permissionFor[key]]: true } })
            }
            this.setState({ titlePrefix: data.titlePrefix })
            this.setState({ Title: data.title })
            this.setState({ firstName: data.firstName })
            this.setState({ lastName: data.lastName })
            this.setState({ Day: data.day })
            this.setState({ Month: data.month })
            this.setState({ Year: data.year })
            this.setState({ postCode: data.postCode })
            this.setState({ phone: data.phone })
            this.setState({ email: data.email })
            this.setState({ companyAddress: data.companyAddress })
            this.setState({ companyCity: data.companyCity })
            this.setState({ companyWebsite: data.companyWebsite })
            this.setState({ invoiceAddress: data.invoiceAddress })
            this.setState({ invoiceCity: data.invoiceCity })
            this.setState({ invoiceEmail: data.invoiceEmail })
            this.setState({ contribution: data.subscriptionType })
            this.setState({ dayRO: data.roDay })
            this.setState({ monthRO: data.roMonth })
            this.setState({ yearRO: data.roYear })
            this.setState({ dayRTb: data.rTbDay })
            this.setState({ monthRTb: data.rTbMonth })
            this.setState({ yearRTb: data.rTbYear })
            this.setState({ overflowPE: data.overflowPE })
        });
    }
    // Function that will be executed when the submit button (Lid toevoegen) is pressed
    handleSubmit(event) {
        event.preventDefault()
        var formData = new FormData()
        Object.keys(this.state).forEach(e => {
            if (e === "permissionFor" || e === "manageAccess" || e === "groups" || e === "Materials") {
                var newObj = []
                for (var key in this.state[e]) {
                    if (this.state[e][key] === true) {
                        newObj.push(parseInt(key));
                    }
                }
                formData.append(e, newObj.join())
            } else {
                formData.append(e, this.state[e])
            }


        })

        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)


        // TODO: Post payload to the API
        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(response => {
                if (response !== undefined) {
                    Api.print(response)
                    this.setState({ errors: response });
                }
                else {
                    alert("Leden updated")
                    // this.emptyForm()
                    // TODO: Show message OK, redirect to the previous page or something like this
                }
            })
    }

    // Function to manage the changes of the text fields and selects
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ [name]: value })
    }

    // Function to manage the changes of the checkboxes
    handleCheckboxChange(event) {
        const target = event.target
        const name = target.name
        const checked = target.checked
        this.setState({ [name]: checked })
    }

    // Function to manage the changes of the array checkboxes
    handleCheckboxArrayChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        const checked = target.checked
        this.setState({ [name]: { ...this.state[name], [value]: checked } })
    }
    render() {

        return (
            <div>
                <Form horizontal className="text-left" onSubmit={this.handleSubmit}>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={6} sm={12}>
                                    <FormGroup controlId="formHorizontalEmail">
                                        <Col componentClass={ControlLabel} sm={5}>
                                            Lidnummer
                                        </Col>
                                        <Col sm={7}>
                                            <FormControl.Static name="memberNumber" value={this.state.memberNumber}>
                                                {this.state.memberIdOld}
                                            </FormControl.Static>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup controlId="formHorizontalEmail">
                                        <Col componentClass={ControlLabel} sm={5}>
                                            Actief
                                        </Col>
                                        <Col sm={7}>
                                            <Checkbox name="active" checked={this.state.active} onChange={this.handleCheckboxChange} />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup controlId="formHorizontalEmail">
                                        <Col componentClass={ControlLabel} sm={5}>
                                            Laatst ingelogd
                                        </Col>
                                        <Col sm={7}>
                                            <FormControl.Static>
                                                {this.state.memberLastLogin}
                                            </FormControl.Static>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col md={6} sm={12}>
                                    <FormGroup controlId="formHorizontalEmail">
                                        <Col componentClass={ControlLabel} sm={5}>
                                            Mededeling
                                        </Col>
                                        <Col sm={7}>
                                            <FormControl componentClass="textarea" name="announcements" value={this.state.announcements} rows="4" onChange={this.handleChange} />
                                            {Api.showError(this.state.errors, "announcements")}
                                        </Col>
                                    </FormGroup>
                                    <br />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} sm={12}>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Geslacht
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" name="gender" value={this.state.gender} placeholder="" onChange={this.handleChange}>
                                        <option value="-1">-- kies --</option>
                                        <option value="0">Man</option>
                                        <option value="1">Vrouw</option>
                                    </FormControl>
                                    {Api.showError(this.state.errors, "gender")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Voorletters
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="initials" value={this.state.initials} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "initials")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Tussenvoegsel
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="middleName" value={this.state.middleName} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "middleName")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Titel na achternaam
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" name="titlePrefix" value={this.state.titlePrefix} placeholder="" onChange={this.handleChange}>
                                        <option value="-1">-- kies --</option>
                                        {Api.getTitlesAfterLastName().map((title, index) =>
                                            <option
                                                value={title}
                                                key={"titlePrefix" + index}>
                                                {title}
                                            </option>
                                        )}
                                    </FormControl>
                                    {Api.showError(this.state.errors, "titlePrefix")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Adres
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="address" required value={this.state.address} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "address")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Plaats
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="city" required value={this.state.city} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "city")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Mobiel
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="mobile" value={this.state.mobile} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "mobile")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Bedrijf
                                </Col>
                                <Col sm={7}>
                                    {this.state.company}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Postcode bedrijf
                                </Col>
                                <Col sm={7}>
                                    {this.state.companyPostCode}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Telefoon bedrijf
                                </Col>
                                <Col sm={7}>
                                    {this.state.companyPhone}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Functie
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="function" value={this.state.function} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "function")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Postcode factuur
                                </Col>
                                <Col sm={7}>
                                    {this.state.invoicePostCode}
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Opdrachtnummer
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="orderNumber" value={this.state.orderNumber} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "orderNumber")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail" className="alignMultiSelect">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Datum aanvraag
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" placeholder="" name="submissionDay" value={this.state.submissionDay} onChange={this.handleChange}>
                                        <option value="0">-- dag --</option>
                                        {getDayOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="submissionMonth" value={this.state.submissionMonth} onChange={this.handleChange}>
                                        <option value="0">-- maand --</option>
                                        {getMonthOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="submissionYear" value={this.state.submissionYear} onChange={this.handleChange}>
                                        <option value="0">-- jaar --</option>
                                        {getYearOptions()}
                                    </FormControl>
                                    {Api.showError(this.state.errors, "submissionDay")}
                                    {Api.showError(this.state.errors, "submissionMonth")}
                                    {Api.showError(this.state.errors, "submissionYear")}
                                </Col>
                            </FormGroup>
                            <br /><br /><br />

                            <FormGroup controlId="formHorizontalEmail" className="alignMultiSelect">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Datum RC
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" placeholder="" name="dayRC" value={this.state.dayRC} onChange={this.handleChange}>
                                        <option value="0">-- dag --</option>
                                        {getDayOptions}
                                    </FormControl>

                                    <FormControl componentClass="select" placeholder="" name="monthRC" value={this.state.monthRC} onChange={this.handleChange}>
                                        <option value="0">-- maand --</option>
                                        {getMonthOptions}
                                    </FormControl>

                                    <FormControl componentClass="select" placeholder="" name="yearRC" value={this.state.yearRC} onChange={this.handleChange}>
                                        <option value="0">-- jaar --</option>
                                        {getYearOptions()}
                                    </FormControl>
                                    {Api.showError(this.state.errors, "dayRC")}
                                    {Api.showError(this.state.errors, "monthRC")}
                                    {Api.showError(this.state.errors, "yearRC")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail" className="alignMultiSelect">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Datum RT a
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" placeholder="" name="dayRTa" value={this.state.dayRTa} onChange={this.handleChange}>
                                        <option value="0">-- dag --</option>
                                        {getDayOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="monthRTa" value={this.state.monthRTa} onChange={this.handleChange}>
                                        <option value="0">-- maand --</option>
                                        {getMonthOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="yearRTa" value={this.state.yearRTa} onChange={this.handleChange}>
                                        <option value="0">-- jaar --</option>
                                        {getYearOptions()}
                                    </FormControl>
                                    {Api.showError(this.state.errors, "dayRTa")}
                                    {Api.showError(this.state.errors, "monthRTa")}
                                    {Api.showError(this.state.errors, "yearRTa")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Status
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" placeholder="" name="status" value={this.state.status} onChange={this.handleChange}>
                                        <option>-- kies --</option>
                                        {Api.getStates().map((state, index) =>
                                            <option
                                                value={index}
                                                key={"status" + index}>
                                                {state}
                                            </option>
                                        )}
                                    </FormControl>
                                    {Api.showError(this.state.errors, "status")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail" className="alignMultiSelect">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Datum hertoetsing
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" placeholder="" name="DateFirstReExaminationDay" value={this.state.DateFirstReExaminationDay} onChange={this.handleChange}>
                                        <option value="0">-- dag --</option>
                                        {getDayOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="DateFirstReExaminationMonth" value={this.state.DateFirstReExaminationMonth} onChange={this.handleChange}>
                                        <option value="0">-- maand --</option>
                                        {getMonthOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="DateFirstReExaminationYear" value={this.state.DateFirstReExaminationYear} onChange={this.handleChange}>
                                        <option value="0">-- jaar --</option>
                                        {getYearOptionsPlus()}
                                    </FormControl>
                                    {Api.showError(this.state.errors, "DateFirstReExaminationDay")}
                                    {Api.showError(this.state.errors, "DateFirstReExaminationMonth")}
                                    {Api.showError(this.state.errors, "DateFirstReExaminationYear")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Werkgebieden
                                </Col>
                                <Col sm={7}>
                                    <Row>
                                        <Col sm={6} xs={6}>
                                            {Api.getWorkAreas().slice(0, 6).map((area, index) =>
                                                <Checkbox
                                                    name="Materials"
                                                    value={index + 1}
                                                    key={"area0_" + index}
                                                    checked={this.state.Materials[index + 1]}
                                                    onChange={this.handleCheckboxArrayChange}>
                                                    {area}
                                                </Checkbox>
                                            )}
                                        </Col>
                                        <Col sm={6} xs={6}>
                                            {Api.getWorkAreas().slice(6).map((area, index) =>
                                                <Checkbox
                                                    name="Materials"
                                                    value={index + 7}
                                                    key={"area1_" + index}
                                                    checked={this.state.Materials[index + 7]}
                                                    onChange={this.handleCheckboxArrayChange}>
                                                    {area}
                                                </Checkbox>
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                            </FormGroup>
                            <br />
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Afbeelding lid
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="file" inputRef={input => this.fileInput = input} />
                                    <Checkbox name="deleteImage" checked={this.state.deleteImage} onChange={this.handleCheckboxChange}>Afbeelding verwijderen</Checkbox>
                                    {Api.showError(this.state.errors, "file")}
                                </Col>
                            </FormGroup>
                            <br />
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Groepen
                        </Col>
                                <Col sm={7}>
                                    <Row>
                                        <Col sm={6} xs={6}>
                                            {
                                                this.state.AllGroups.map(group =>
                                                    <Checkbox
                                                        name="groups"
                                                        value={group.id}
                                                        key={"group" + group.id}
                                                        checked={this.state.groups[group.id]}
                                                        onChange={this.handleCheckboxArrayChange}>
                                                        {group.name}
                                                    </Checkbox>
                                                )}
                                        </Col>
                                        <Col sm={6} xs={6}>
                                            {this.state.AllGroups2.map(group =>
                                                <Checkbox
                                                    name="groups"
                                                    value={group.id}
                                                    key={"group" + group.id}
                                                    checked={this.state.groups[group.id]}
                                                    onChange={this.handleCheckboxArrayChange}>
                                                    Groep {group.name}
                                                </Checkbox>
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col md={6} sm={12}>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Titel voor achternaam
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" placeholder="" name="Title" value={this.state.Title} onChange={this.handleChange}>
                                        <option value="-1">-- kies --</option>
                                        {Api.getTitlesForLastName().map((title, index) =>
                                            <option
                                                value={title}
                                                key={"titleFor" + index}>
                                                {title}
                                            </option>
                                        )}
                                    </FormControl>
                                    {Api.showError(this.state.errors, "Title")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Voornaam
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="firstName" required value={this.state.firstName} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "firstName")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Achternaam
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="lastName" required value={this.state.lastName} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "lastName")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail" className="alignMultiSelect">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Geboortedatum
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" placeholder="" name="Day" value={this.state.Day} onChange={this.handleChange}>
                                        <option value="0">-- dag --</option>
                                        {getDayOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="Month" value={this.state.Month} onChange={this.handleChange}>
                                        <option value="0">-- maand --</option>
                                        {getMonthOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="Year" value={this.state.Year} onChange={this.handleChange}>
                                        <option value="0">-- jaar --</option>
                                        {getYearOptions()}
                                    </FormControl>
                                    {Api.showError(this.state.errors, "Day")}
                                    {Api.showError(this.state.errors, "Month")}
                                    {Api.showError(this.state.errors, "Year")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Postcode
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="postCode" required value={this.state.postCode} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "postCode")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Telefoon
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="phone" value={this.state.phone} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "phone")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="">
                                <Col componentClass={ControlLabel} sm={5}>
                                    E-mail
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="email" required value={this.state.email} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "email")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Adres bedrijf
                                </Col>
                                <Col sm={7}>
                                    {this.state.companyAddress}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Plaats bedrijf
                                </Col>
                                <Col sm={7}>
                                    {this.state.companyCity}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Website bedrijf
                                </Col>
                                <Col sm={7}>
                                    {this.state.companyWebsite}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Adres factuur
                                </Col>
                                <Col sm={7}>
                                    {this.state.invoiceAddress}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Plaats factuur
                                </Col>
                                <Col sm={7}>
                                    {this.state.invoiceCity}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="">
                                <Col componentClass={ControlLabel} sm={5}>
                                    mail factuuradres
                                </Col>
                                <Col sm={7}>
                                    {this.state.invoiceEmail}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Contributie
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" placeholder="" name="contribution" value={this.state.contribution} onChange={this.handleChange}>
                                        <option value="-1">-- kies --</option>
                                        <option value="0">Zelf betalen</option>
                                        <option value="1" class="cambiaaa">Werkgever betaalt</option>
                                    </FormControl>
                                    {Api.showError(this.state.errors, "contribution")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Status aanvraag
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="textarea" name="requestStatus" value={this.state.requestStatus} rows="4" onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "requestStatus")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail" className="alignMultiSelect">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Datum RO
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" placeholder="" name="dayRO" value={this.state.dayRO} onChange={this.handleChange}>
                                        <option value="0">-- dag --</option>
                                        {getDayOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="monthRO" value={this.state.monthRO} onChange={this.handleChange}>
                                        <option value="0">-- maand --</option>
                                        {getMonthOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="yearRO" value={this.state.yearRO} onChange={this.handleChange}>
                                        <option value="0">-- jaar --</option>
                                        {getYearOptions()}
                                    </FormControl>
                                    {Api.showError(this.state.errors, "dayRO")}
                                    {Api.showError(this.state.errors, "monthRO")}
                                    {Api.showError(this.state.errors, "yearRO")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail" className="alignMultiSelect">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Datum RT b
                                </Col>
                                <Col sm={7}>
                                    <FormControl componentClass="select" placeholder="" name="dayRTb" value={this.state.dayRTb} onChange={this.handleChange}>
                                        <option value="0">-- dag --</option>
                                        {getDayOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="monthRTb" value={this.state.monthRTb} onChange={this.handleChange}>
                                        <option value="0">-- maand --</option>
                                        {getMonthOptions}
                                    </FormControl>
                                    <FormControl componentClass="select" placeholder="" name="yearRTb" value={this.state.yearRTb} onChange={this.handleChange}>
                                        <option value="0">-- jaar --</option>
                                        {getYearOptions()}
                                    </FormControl>
                                    {Api.showError(this.state.errors, "dayRTb")}
                                    {Api.showError(this.state.errors, "monthRTb")}
                                    {Api.showError(this.state.errors, "yearRTb")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Overflow PE hertoetsing
                                </Col>
                                <Col sm={7}>
                                    <FormControl type="text" name="overflowPE" value={this.state.overflowPE} onChange={this.handleChange} />
                                    {Api.showError(this.state.errors, "overflowPE")}
                                </Col>
                            </FormGroup>
                            <br />
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Toegang tot beheren
                                </Col>
                                <Col sm={7}>
                                    {Api.getManageAccess().map((access, i) =>
                                        <Checkbox
                                            name="manageAccess"
                                            value={i * 2 + 1}
                                            key={"access" + (i * 2 + 1)}
                                            checked={this.state.manageAccess[i * 2 + 1]}
                                            onChange={this.handleCheckboxArrayChange}>
                                            {access}
                                        </Checkbox>
                                    )}
                                </Col>
                            </FormGroup><br />
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Toestemming voor
                        </Col>
                                <Col sm={7}>
                                    {Api.getMemberPermissions().map((perm, index) =>
                                        <Checkbox
                                            name="permissionFor"
                                            value={index}
                                            key={"perm" + index}
                                            checked={this.state.permissionFor[index]}
                                            onChange={this.handleCheckboxArrayChange}>
                                            {perm}
                                        </Checkbox>
                                    )}
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Button type="submit">Wijzigingen opslaan</Button>
                            {Api.showError(this.state.errors, "General")}
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }
}
export default Gegevens;




// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Gegevens.js